/* ============================================================
   NIMBUS theme — storefront behaviour.
   Cart mutations go through Shopify's AJAX Cart API and re-render
   the drawer with the Section Rendering API, so the drawer markup
   lives in Liquid (snippets/cart-drawer-body.liquid) only.
   ============================================================ */
(function () {
  'use strict';

  var R = Object.assign(
    { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update', cart_url: '/cart', root_url: '/' },
    window.NimbusRoutes || {}
  );
  var MONEY = window.NimbusMoneyFormat || '${{amount}}';
  var STR = Object.assign({ soldOut: 'Sold out', unavailable: 'Unavailable', error: 'Something went wrong. Please try again.' }, window.NimbusStrings || {});

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stripTags(s) { return String(s == null ? '' : s).replace(/<[^>]*>/g, ''); }
  function parseJSON(s, fallback) { try { return s ? JSON.parse(s) : fallback; } catch (e) { return fallback; } }
  function checkoutUrl() { var root = R.root_url === '/' ? '' : R.root_url.replace(/\/$/, ''); return root + '/checkout'; }

  /* ---------- money (mirrors Shopify's money filter using shop.money_format) ---------- */
  function formatMoney(cents, format) {
    format = format || MONEY;
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands == null ? ',' : thousands; decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100.0).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return stripTags(format.replace(placeholder, value));
  }

  /* ---------- cart drawer ---------- */
  var Cart = {
    lastFocus: null,
    el: function () { return $('#CartDrawer'); },
    overlay: function () { return $('#CartOverlay'); },
    body: function () { return $('[data-cart-drawer-body]'); },
    isOpen: function () { var d = this.el(); return !!(d && d.classList.contains('on')); },
    open: function () {
      var d = this.el(); if (!d) return;
      this.lastFocus = document.activeElement;
      d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
      var o = this.overlay(); if (o) o.classList.add('on');
      document.body.classList.add('drawer-open');
      setTimeout(function () { var f = $('[data-action="close-cart"]', d) || d; f.focus({ preventScroll: true }); }, 60);
    },
    close: function () {
      var d = this.el(); if (!d) return;
      d.classList.remove('on'); d.setAttribute('aria-hidden', 'true');
      var o = this.overlay(); if (o) o.classList.remove('on');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },
    request: function (url, payload) {
      var self = this, d = this.el();
      payload = Object.assign({}, payload, { sections: 'cart-drawer', sections_url: window.location.pathname });
      if (d) d.classList.add('is-loading');
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.data.description || r.data.message || STR.error);
          self.render(r.data.sections);
          return r.data;
        })
        .finally(function () { if (d) d.classList.remove('is-loading'); });
    },
    render: function (sections) {
      var html = sections && sections['cart-drawer']; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.getElementById('shopify-section-cart-drawer') || doc.body;
      var body = this.body(); if (body) body.innerHTML = src.innerHTML;
      this.syncCount();
    },
    syncCount: function () {
      var n = $('[data-cart-item-count]'); if (!n) return;
      var count = n.getAttribute('data-cart-item-count');
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    },
    error: function (msg) { var e = $('[data-cart-error]'); if (e) e.textContent = msg || ''; },
    add: function (items) { var self = this; this.error(''); return this.request(R.cart_add_url + '.js', { items: items }).then(function (d) { self.open(); return d; }); },
    change: function (key, quantity) { this.error(''); return this.request(R.cart_change_url + '.js', { id: key, quantity: quantity }); },
    update: function (updates) { this.error(''); return this.request(R.cart_update_url + '.js', { updates: updates }); },
    fetch: function () { return fetch(R.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  };

  function withLoading(btn, fn, scope) {
    var errEl = scope ? $('[data-form-error]', scope) : null;
    if (errEl) errEl.textContent = '';
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return Promise.resolve().then(fn).catch(function (e) {
      var msg = (e && e.message) || STR.error;
      if (errEl) errEl.textContent = msg; else { Cart.error(msg); Cart.open(); }
    }).finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  function handleAdd(btn) {
    var id = Number(btn.getAttribute('data-variant-id')); if (!id) return;
    var item = { id: id, quantity: Number(btn.getAttribute('data-quantity') || 1) };
    var plan = btn.getAttribute('data-selling-plan'); if (plan) item.selling_plan = Number(plan);
    var props = parseJSON(btn.getAttribute('data-properties'), null); if (props) item.properties = props;
    return withLoading(btn, function () { return Cart.add([item]); }, btn.closest('[data-error-scope]'));
  }

  function convertToSub(btn) {
    var lines = $$('[data-line][data-convert-plan]', Cart.body()).map(function (l) {
      return { key: l.getAttribute('data-line'), id: Number(l.getAttribute('data-variant-id')), qty: Number(l.getAttribute('data-quantity')), plan: Number(l.getAttribute('data-convert-plan')) };
    }).filter(function (l) { return l.plan && l.id; });
    if (!lines.length) return;
    return withLoading(btn, function () {
      var updates = {}; lines.forEach(function (l) { updates[l.key] = 0; });
      return Cart.update(updates).then(function () {
        return Cart.add(lines.map(function (l) { return { id: l.id, quantity: l.qty, selling_plan: l.plan }; }));
      });
    });
  }

  /* ---------- purchase option (one-time / subscribe) on cards ---------- */
  function pickOption(container, mode) {
    $$('.opt', container).forEach(function (o) { var i = $('input', o); o.classList.toggle('on', !!(i && i.value === mode)); });
    var btn = $('[data-action="add"]', container); if (!btn) return;
    if (mode === 'sub' && container.getAttribute('data-plan-id')) {
      btn.setAttribute('data-selling-plan', container.getAttribute('data-plan-id'));
      btn.textContent = container.getAttribute('data-label-sub') || btn.textContent;
    } else {
      btn.removeAttribute('data-selling-plan');
      btn.textContent = container.getAttribute('data-label-one') || btn.textContent;
    }
  }

  /* ---------- product page form ---------- */
  function initProductForms() {
    $$('[data-product]').forEach(function (root) {
      var form = $('[data-product-form]', root), jsonEl = $('[data-product-json]', root);
      if (!form || !jsonEl) return;
      var product = parseJSON(jsonEl.textContent, null); if (!product) return;
      var btn = $('[type="submit"]', form), idInput = $('input[name="id"]', form), planInput = $('input[name="selling_plan"]', form);
      var priceEl = $('[data-price]', root), onePriceEl = $('[data-one-price]', root), subPriceEl = $('[data-sub-price]', root);

      function selectedVariant() {
        var values = [];
        $$('[data-option-index]', root).forEach(function (el) {
          var i = Number(el.getAttribute('data-option-index'));
          if (el.tagName === 'SELECT') values[i] = el.value; else if (el.checked) values[i] = el.value;
        });
        if (!values.length) return product.variants[0] || null;
        for (var k = 0; k < product.variants.length; k++) {
          var v = product.variants[k], hit = true;
          for (var i = 0; i < v.options.length; i++) if (v.options[i] !== values[i]) { hit = false; break; }
          if (hit) return v;
        }
        return null;
      }
      function priceHtml(price, compare) {
        return (compare && compare > price ? '<s>' + esc(formatMoney(compare)) + '</s>' : '') + esc(formatMoney(price));
      }
      function update() {
        var variant = selectedVariant();
        var modeInput = $('input[data-purchase-option]:checked', root);
        var mode = modeInput ? modeInput.value : 'one';
        $$('.opt', root).forEach(function (o) { var i = $('input', o); o.classList.toggle('on', !!(i && i.value === mode)); });
        if (!variant) { if (btn) { btn.disabled = true; btn.textContent = STR.unavailable; } return; }
        if (idInput) idInput.value = variant.id;
        var allocs = variant.selling_plan_allocations || [];
        var alloc = mode === 'sub' && allocs.length ? allocs[0] : null;
        if (planInput) planInput.value = alloc ? alloc.selling_plan_id : '';
        if (priceEl) priceEl.innerHTML = alloc ? priceHtml(alloc.price, alloc.compare_at_price) : priceHtml(variant.price, variant.compare_at_price);
        if (onePriceEl) onePriceEl.innerHTML = priceHtml(variant.price, variant.compare_at_price);
        if (subPriceEl && allocs.length) subPriceEl.textContent = formatMoney(allocs[0].price);
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = !variant.available ? STR.soldOut : (alloc ? (btn.getAttribute('data-label-sub') || btn.textContent) : (btn.getAttribute('data-label-one') || btn.textContent));
        }
        if (variant.featured_media && variant.featured_media.id) showMedia(root, variant.featured_media.id);
        try { if (product.variants.length > 1) history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id); } catch (e) {}
      }
      root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index], input[data-purchase-option]')) update(); });
      update();
    });
  }
  function showMedia(root, mediaId) {
    var any = false;
    $$('[data-media-id]', root).forEach(function (m) {
      var on = String(m.getAttribute('data-media-id')) === String(mediaId);
      if (m.hasAttribute('data-media-thumb')) m.setAttribute('aria-current', on ? 'true' : 'false'); else { m.hidden = !on; if (on) any = true; }
    });
    if (!any) { var first = $('[data-media-id]:not([data-media-thumb])', root); if (first) first.hidden = false; }
  }

  /* ---------- rotation builder ---------- */
  function initRotation() {
    $$('[data-rotation]').forEach(function (b) {
      var prices = [0, Number(b.getAttribute('data-price-1')) || 0, Number(b.getAttribute('data-price-2')) || 0, Number(b.getAttribute('data-price-3')) || 0];
      var notes = ['', b.getAttribute('data-note-1') || '', b.getAttribute('data-note-2') || '', b.getAttribute('data-note-3') || ''];
      var labels = ['', b.getAttribute('data-label-1') || '', b.getAttribute('data-label-2') || '', b.getAttribute('data-label-3') || ''];
      var max = Number(b.getAttribute('data-max') || 3);
      function picks() { return $$('[data-action="rotation-pick"][aria-pressed="true"]', b); }
      function render() {
        var n = picks().length;
        $$('.rung', b).forEach(function (r) { r.classList.toggle('on', Number(r.getAttribute('data-n')) === n); });
        $$('[data-action="rotation-pick"]', b).forEach(function (p) { p.disabled = n >= max && p.getAttribute('aria-pressed') !== 'true'; });
        var tot = $('[data-rotation-total]', b), note = $('[data-rotation-note]', b), btn = $('[data-action="rotation-add"]', b);
        if (!n) { if (tot) tot.textContent = b.getAttribute('data-empty-label') || ''; if (note) note.innerHTML = '&nbsp;'; if (btn) btn.disabled = true; return; }
        if (btn) btn.disabled = false;
        var full = prices[1] * n, p = prices[n] || prices[1] * n;
        if (tot) tot.innerHTML = (n > 1 && full > p ? '<s>' + esc(formatMoney(full)) + '</s>' : '') + esc(formatMoney(p));
        if (note) note.textContent = (notes[n] || '').replace('[savings]', formatMoney(Math.max(0, full - p)));
      }
      function addRotation(btn) {
        var chosen = picks(), n = chosen.length; if (!n) return;
        var titles = chosen.map(function (p) { return p.getAttribute('data-title') || ''; });
        var items = null;
        var bundle = n === 2 ? parseJSON(b.getAttribute('data-pair-variants'), []) : n === 3 ? parseJSON(b.getAttribute('data-trio-variants'), []) : [];
        if (bundle && bundle.length) {
          var norm = function (s) { return String(s || '').toLowerCase(); };
          var match = null;
          for (var i = 0; i < bundle.length; i++) {
            var v = bundle[i]; if (!v.available) continue;
            var all = titles.every(function (t) { return norm(v.title).indexOf(norm(t)) !== -1; });
            if (all) { match = v; break; }
          }
          if (!match && n === 3) match = bundle.filter(function (v) { return v.available; })[0] || null;
          if (match) { var props = {}; props[b.getAttribute('data-prop-skies') || 'Skies'] = titles.join(' + '); items = [{ id: match.id, quantity: 1, properties: props }]; }
        }
        if (!items) {
          items = chosen.map(function (p) {
            var it = { id: Number(p.getAttribute('data-variant-id')), quantity: 1 };
            if (n > 1) { var pr = {}; pr[b.getAttribute('data-prop-rotation') || 'Rotation'] = labels[n] || String(n); it.properties = pr; }
            return it;
          });
        }
        return withLoading(btn, function () { return Cart.add(items); }, b);
      }
      b.addEventListener('click', function (e) {
        var p = e.target.closest('[data-action="rotation-pick"]');
        if (p) { p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); render(); return; }
        var a = e.target.closest('[data-action="rotation-add"]'); if (a) addRotation(a);
      });
      render();
    });
  }

  /* ---------- pre-checkout offer ---------- */
  var Offer = {
    timer: null, variant: null,
    el: function () { return $('#CheckoutOffer'); },
    seen: function () { try { return sessionStorage.getItem('nimbus-offer-seen') === '1'; } catch (e) { return false; } },
    markSeen: function () { try { sessionStorage.setItem('nimbus-offer-seen', '1'); } catch (e) {} },
    intercept: function () {
      var el = this.el(); if (!el || el.getAttribute('data-enabled') !== 'true' || this.seen()) return false;
      var variants = parseJSON(el.getAttribute('data-variants'), []).filter(function (v) { return v.available; });
      if (!variants.length) return false;
      this.show(variants); return true;
    },
    show: function (variants) {
      var self = this, el = this.el();
      this.markSeen();
      this.variant = variants[0];
      Cart.close();
      Cart.fetch().then(function (cart) {
        var first = cart && cart.items && cart.items[0];
        if (!first) return;
        var t = String(first.product_title || '').toLowerCase();
        var hit = variants.filter(function (v) { var vt = String(v.title || '').toLowerCase(); return t.indexOf(vt) !== -1 || vt.indexOf(t) !== -1; })[0];
        if (hit) self.variant = hit;
        var tpl = el.getAttribute('data-name-template'), nm = $('[data-offer-name]', el);
        if (tpl && nm) nm.textContent = tpl.replace('[sky]', first.product_title.toUpperCase());
        var stpl = el.getAttribute('data-sub-template'), sn = $('[data-offer-sub]', el);
        if (stpl && sn) sn.textContent = stpl.replace('[sky]', first.product_title.toUpperCase());
      }).catch(function () {}).finally(function () {
        var v = self.variant, pr = $('[data-offer-price]', el), cta = $('[data-offer-cta]', el);
        if (pr) pr.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + esc(formatMoney(v.compare_at_price)) + '</s>' : '') + esc(formatMoney(v.price));
        if (cta && cta.getAttribute('data-cta-template')) cta.textContent = cta.getAttribute('data-cta-template').replace('[price]', formatMoney(v.price));
        el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
        var f = $('[data-action="offer-accept"]', el); if (f) f.focus({ preventScroll: true });
        self.startTimer();
      });
    },
    startTimer: function () {
      var el = this.el(), self = this, out = $('[data-offer-timer]', el);
      var t = Math.round(Number(el.getAttribute('data-minutes') || 0) * 60);
      clearInterval(this.timer);
      if (!t || !out) return;
      var tick = function () { out.textContent = Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0'); if (t <= 0) { clearInterval(self.timer); self.hide(); } t--; };
      tick(); this.timer = setInterval(tick, 1000);
    },
    accept: function (btn) {
      var self = this;
      return withLoading(btn, function () {
        return Cart.request(R.cart_add_url + '.js', { items: [{ id: self.variant.id, quantity: 1 }] }).then(function () { self.proceed(); });
      }, this.el());
    },
    skip: function () { this.proceed(); },
    proceed: function () { this.hide(); window.location.href = checkoutUrl(); },
    hide: function () { var el = this.el(); if (!el) return; el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); clearInterval(this.timer); }
  };

  /* ---------- email capture ---------- */
  function initPopup() {
    var pop = $('#EmailPopup'); if (!pop) return;
    var KEY = 'nimbus-popup';
    var store = {
      get: function () { try { return parseJSON(localStorage.getItem(KEY), null); } catch (e) { return null; } },
      set: function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    };
    var stateEl = $('[data-popup-state]', pop);
    var posted = stateEl ? stateEl.getAttribute('data-popup-state') : '';
    if (posted === 'success') { pop.classList.add('on'); store.set({ done: true }); return; }
    if (posted === 'error') { pop.classList.add('on'); return; }
    var st = store.get();
    if (st && (st.done || (st.dismissed && Date.now() - st.dismissed < 7 * 864e5))) return;
    setTimeout(function () { if (!Cart.isOpen()) pop.classList.add('on'); }, Number((stateEl && stateEl.getAttribute('data-delay')) || 9) * 1000);
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="popup-close"]')) { pop.classList.remove('on'); store.set({ dismissed: Date.now() }); }
    });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]'); if (!t) return;
    switch (t.getAttribute('data-action')) {
      case 'open-cart': e.preventDefault(); Cart.open(); break;
      case 'close-cart': e.preventDefault(); Cart.close(); break;
      case 'add': e.preventDefault(); handleAdd(t); break;
      case 'cart-change': e.preventDefault(); Cart.change(t.getAttribute('data-key'), Number(t.getAttribute('data-quantity'))).catch(function (err) { Cart.error(err.message || STR.error); }); break;
      case 'convert-sub': e.preventDefault(); convertToSub(t); break;
      case 'offer-accept': e.preventDefault(); Offer.accept(t); break;
      case 'offer-skip': e.preventDefault(); Offer.skip(); break;
      case 'show-media': e.preventDefault(); showMedia(t.closest('[data-product]'), t.getAttribute('data-media-id')); break;
      case 'qty-inc': case 'qty-dec': {
        e.preventDefault();
        var input = $('input', t.closest('.qty-field')); if (!input) break;
        var min = Number(input.min || 1), v = Number(input.value || min) + (t.getAttribute('data-action') === 'qty-inc' ? 1 : -1);
        input.value = Math.max(min, v); input.dispatchEvent(new Event('change', { bubbles: true })); break;
      }
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-purchase-option]');
    if (input) { var card = input.closest('[data-product-card]'); if (card) pickOption(card, input.value); }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-product-form]')) {
      e.preventDefault();
      var fd = new FormData(form);
      var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      var plan = fd.get('selling_plan'); if (plan) item.selling_plan = Number(plan);
      var props = {}, has = false;
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') { props[m[1]] = v; has = true; } });
      if (has) item.properties = props;
      withLoading($('[type="submit"]', form), function () { return Cart.add([item]); }, form);
      return;
    }
    if (form.matches('[data-cart-checkout-form]')) { if (Offer.intercept()) e.preventDefault(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var offer = Offer.el();
    if (offer && offer.classList.contains('on')) { Offer.hide(); return; }
    if (Cart.isOpen()) Cart.close();
  });

  initProductForms();
  initRotation();
  initPopup();
  Cart.syncCount();

  window.Nimbus = { Cart: Cart, formatMoney: formatMoney };
})();
